import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';
import editorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import cssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker';
import htmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker';
import jsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import tsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';

/**
 * Configure Monaco Editor to load from local node_modules instead of CDN.
 * This is required because the staging/production CSP blocks cdn.jsdelivr.net.
 *
 * @see https://github.com/suren-atoyan/monaco-react#use-monaco-editor-as-an-npm-package
 */
self.MonacoEnvironment = {
  getWorker(_, label) {
    if (label === 'json') {
      return new jsonWorker();
    }
    if (label === 'css' || label === 'scss' || label === 'less') {
      return new cssWorker();
    }
    if (label === 'html' || label === 'handlebars' || label === 'razor') {
      return new htmlWorker();
    }
    if (label === 'typescript' || label === 'javascript') {
      return new tsWorker();
    }
    return new editorWorker();
  }
};

// Configure the loader to use the local monaco instance from node_modules
// eslint-disable-next-line @typescript-eslint/no-explicit-any
loader.config({ monaco: monaco as any });

// Pre-initialize the loader to avoid delays when the first editor mounts
loader.init();
